'use strict';


/* ========================================================
 * 		jQuery
 *
 * If you need jQuery in a JS file add this to the top of that file:
 * 		var $ = require('jquery');
 * If some JS code MUST have jQuery globally accessible then
 * add the following line inside this file (index.js).
 * 		var $ = window.jQuery = require('jquery');
 ========================================================= */
 var $ = require('jquery');

/* ========================================================
 * 		Requires
 ========================================================= */
// Browser specific detection
var detectBrowser = require('./lib/detectBrowser.js');
detectBrowser.addStyleClasses();

// Polyfills
require('./polyfills/requestAnimationFrame.js');

// Lib
require('@plaudit/jsf-ajax-adapters/dist/jQuery').default.init();

// Analytics
require('./AnalyticsSetup.ts');

/* ========================================================
 * 		Component Setup
 ========================================================= */
require('./lib/Forms.js').init();
require('./site/MainMenu.js').init();
require('./site/TabContent.js').init();
require('./site/CollapsableGroup.js').init();
require('./site/SearchDropdown.js').init();
require('./site/EmailSigBuilder.js').init();
require('./site/FormMask.js').init();
require('./site/Directors.js').init();
require('./site/CountUp.js').init({
	item: 'statsBar__statValueNumber',
	itemParent: 'statsBar',
	variableSpeed: true
});

require('./site/formLightbox.js').init();

require('./site/recentClosings.js').init();
// @ts-ignore
// import * as newsletterSignup from './site/newsletterSignup.js';
// newsletterSignup.init();

// Transcript - Toggle 'Active' class
$(function() {
	$(document).on("click", ".transcript__toggleLink", function() {
	  $(".transcript__toggleLink, .transcript__text").toggleClass("open");
	});
});